"use client";

// src/ui/utils/useInputSync.tsx
import { useEffect } from "react";
var useInputSync = ({ setInput, input }, runtime) => {
  useEffect(() => {
    runtime.thread.composer.setText(input);
  }, [runtime, input]);
  useEffect(() => {
    return runtime.thread.composer.subscribe(() => {
      setInput(runtime.thread.composer.getState().text);
    });
  }, [runtime, setInput]);
};
export {
  useInputSync
};
//# sourceMappingURL=useInputSync.js.map